import { Link } from 'react-router-dom'
import { EmptyState, PageHeader } from '@/components'
import { paths } from '@/routes/paths'

export function NotFoundPage() {
  return (
    <div className="page-stack">
      <PageHeader eyebrow="Navegação" title="Página não encontrada" />
      <EmptyState
        title="Este endereço não existe"
        description="Volte ao início para continuar usando o aplicativo."
        action={
          <Link className="button button--primary" to={paths.home}>
            Voltar ao início
          </Link>
        }
      />
    </div>
  )
}
